import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b49a809"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "This is a component testing page", -1))
const _hoisted_2 = { class: "about spacer deneme-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("View Item")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Place a Bid")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("More")
const _hoisted_7 = { class: "mt-16 p-4" }
const _hoisted_8 = { class: "p-16 space-x-4 flex" }
const _hoisted_9 = { class: "py-16" }
const _hoisted_10 = { class: "py-16" }
const _hoisted_11 = {
  class: "py-16 flex",
  style: {"margin-bottom":"2000px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_NewsletterButton = _resolveComponent("NewsletterButton")!
  const _component_BrushIcon = _resolveComponent("BrushIcon")!
  const _component_BaseBanner = _resolveComponent("BaseBanner")!
  const _component_TransactionIcon = _resolveComponent("TransactionIcon")!
  const _component_PriceUpIcon = _resolveComponent("PriceUpIcon")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_BaseToaster = _resolveComponent("BaseToaster")!
  const _component_BaseSelectItem = _resolveComponent("BaseSelectItem")!
  const _component_BaseSelect = _resolveComponent("BaseSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BaseButton, {
        size: "lg",
        shadow: true,
        textColor: "primary",
        shadowColor: "primary",
        fontSize: "lg",
        fontWeight: 500
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_BaseButton, {
        size: "xl",
        fontSize: "lg",
        shadow: true,
        fontWeight: 500
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_BaseButton, { class: "font-semibold" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_BaseButton, {
        size: "sm",
        fontSize: "sm",
        shadow: true,
        fontWeight: 500
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_NewsletterButton)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_BaseBanner, {
        primaryText: "75,088",
        secondaryText: "NFTS CREATED"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_BrushIcon)
        ]),
        _: 1
      }),
      _createVNode(_component_BaseBanner, {
        primaryText: "6,736",
        secondaryText: "TRANSACTIONS"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_TransactionIcon)
        ]),
        _: 1
      }),
      _createVNode(_component_BaseBanner, {
        primaryText: "$78,428.76",
        secondaryText: "TOTAL SALES"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_PriceUpIcon)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_BaseCard, {
        isFixedHeight: "",
        isPriceShadowed: ""
      }),
      _createVNode(_component_BaseCard)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_TheFooter)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_BaseToaster, {
        text: "We use cookies for better service.",
        buttonText: "Accept",
        type: "primary"
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_BaseSelect, {
        multiple: "",
        text: "NFTNFTNFTNFTNFTNFTNFTNFTNFTNFTNFT",
        data: _ctx.selectData,
        displayKey: "text"
      }, {
        default: _withCtx(({ multiple, item, displayKey }) => [
          _createVNode(_component_BaseSelectItem, {
            item: item,
            multiple: multiple,
            displayKey: displayKey,
            onSelected: _ctx.handleSelectedData
          }, null, 8, ["item", "multiple", "displayKey", "onSelected"])
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}